import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get salaries
export const getSalaries = createAsyncThunk(
  "Salaries/getSalaries",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);

      const url = `${BASE_URL}/salaries${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get salaries!";
      return rejectWithValue(message);
    }
  },
);

// Add salary
export const addSalary = createAsyncThunk(
  "Salaries/addSalary",
  async (salaryData, { rejectWithValue }) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const currentLang = getCurrentLanguage();
      const response = await axios.post(`${BASE_URL}/salaries`, salaryData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to add salary!";
      return rejectWithValue(message);
    }
  },
);

// Get salary details
export const getSalaryDetails = createAsyncThunk(
  "Salaries/getSalaryDetails",
  async (employeeId, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.get(
        `${BASE_URL}/employees/${employeeId}/salary`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get salary details!";
      return rejectWithValue(message);
    }
  },
);

// Update salary
export const updateSalary = createAsyncThunk(
  "Salaries/updateSalary",
  async ({ id, salaryData }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.put(
        `${BASE_URL}/salaries/${id}`,
        salaryData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to update salary!";
      return rejectWithValue(message);
    }
  },
);
